var map = {
	"./amordadShop": 25758,
	"./amordadShop.jsx": 25758,
	"./bgWallet": 40096,
	"./bgWallet.jsx": 40096,
	"./customerSupport": 39372,
	"./customerSupport.jsx": 39372,
	"./customerSupportForm": 57078,
	"./customerSupportForm.jsx": 57078,
	"./deposit/depositHistory": 27554,
	"./deposit/depositHistory.jsx": 27554,
	"./deposit/topupBGWallet": 16086,
	"./deposit/topupBGWallet.jsx": 16086,
	"./deposit/topupForm": 51718,
	"./deposit/topupForm.jsx": 51718,
	"./home": 30311,
	"./home.jsx": 30311,
	"./myProfile/changeLoginPassword": 12081,
	"./myProfile/changeLoginPassword.jsx": 12081,
	"./myProfile/changeLoginPasswordForm": 81207,
	"./myProfile/changeLoginPasswordForm.jsx": 81207,
	"./myProfile/disable2faForm": 22030,
	"./myProfile/disable2faForm.jsx": 22030,
	"./myProfile/enable2faForm": 35417,
	"./myProfile/enable2faForm.jsx": 35417,
	"./myProfile/googleAuthenticator": 50887,
	"./myProfile/googleAuthenticator.jsx": 50887,
	"./myProfile/profile": 19182,
	"./myProfile/profile.jsx": 19182,
	"./myProfile/profileForm": 9864,
	"./myProfile/profileForm.jsx": 9864,
	"./myProfile/setup2faForm": 29679,
	"./myProfile/setup2faForm.jsx": 29679,
	"./myProfile/verifyCodeForm": 43779,
	"./myProfile/verifyCodeForm.jsx": 43779,
	"./mySeeds": 79721,
	"./mySeeds.jsx": 79721,
	"./news": 34133,
	"./news.jsx": 34133,
	"./privacyPolicy": 83195,
	"./privacyPolicy.jsx": 83195,
	"./rankings": 16618,
	"./rankings.jsx": 16618,
	"./termsAndConditions": 15303,
	"./termsAndConditions.jsx": 15303,
	"./userResource": 9256,
	"./userResource.jsx": 9256,
	"./withdraw/withdrawForm": 3968,
	"./withdraw/withdrawForm.jsx": 3968,
	"./withdraw/withdrawHistory": 11784,
	"./withdraw/withdrawHistory.jsx": 11784,
	"./withdraw/withdrawTokens": 63148,
	"./withdraw/withdrawTokens.jsx": 63148,
	"./xpHistory": 90222,
	"./xpHistory.jsx": 90222
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 90487;